export default __webpack_public_path__ + "static/media/testo-3.17585719.jpg";